module.exports = __webpack_public_path__ + "img/thumb-022.0c7d8705.png";